<template>
  <div class="enroll-pin-view">
    <div class="relative flex flex-col h-screen">
      <img :src="getImage('mascot')" class="fixed papsi-mascot" />
      <div class="flex flex-1 lg:flex-row flex-col">
        <SidebarSection>
          <LabelControl
            v-if="!is_inputting_new_pin && !is_inputting_confirm_pin"
            type="message"
            :content="$t('enp003')"
          />
          <LabelControl
            v-if="is_inputting_new_pin"
            type="message"
            :content="$t('enp003')"
          />
          <LabelControl
            v-if="is_inputting_confirm_pin"
            type="message"
            :content="$t('enp006')"
          />
        </SidebarSection>
        <ContentSection :show_logout="false" :show_back="true" @logout="logout">
          <div class="text-left">
            <!-- Confirm Details -->
            <div
              v-if="!is_inputting_new_pin && !is_inputting_confirm_pin"
              class="flex flex-col justify-center items-center"
            >
              <LabelControl
                class="mb-12 self-start text-left w-full"
                type="heading"
                :content="$t('enp004')"
              />

              <div
                class="bg-grey-lighter p-10 mt-5 rounded-2xl papsi-container-enroll"
              >
                <div class="flex flex-col">
                  <p class="text-grey-darkest text-3xl mb-4">
                    {{ $t("mip005") }}:
                  </p>
                  <div
                    class="flex flex-row bg-white rounded-xl px-6 py-4 justify-between items-center"
                  >
                    <div class="flex flex-row items-center">
                      <IconControl
                        id="smartphone"
                        :height="35"
                        :width="35"
                        class="mr-5"
                      />
                      <p class="text-grey-darkest text-3xl">
                        {{ this.getCensoredNumber }}
                      </p>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col mt-5">
                  <p class="text-grey-darkest text-3xl mb-4">
                    {{ $t("mip006") }}:
                  </p>
                  <div
                    class="flex flex-row bg-white rounded-xl px-6 py-4 justify-between items-center"
                  >
                    <div class="flex flex-row items-center">
                      <IconControl
                        id="mail"
                        :height="35"
                        :width="35"
                        class="mr-5"
                      />
                      <p class="text-grey-darkest text-3xl">
                        {{ this.getCensoredEmail }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="flex flex-row items-center justify-center papsi-button"
                style="width: 50rem"
              >
                <ButtonControl
                  class="w-full"
                  @click="returnToStartPage()"
                  theme="error"
                  :text="$t('btn015')"
                />
                <ButtonControl
                  class="w-full ml-8"
                  @click="is_modal_open = true"
                  theme="success"
                  :text="$t('btn002')"
                />
              </div>

              <OTPModalControl
                :is_enrolling_pin="true"
                ref="PINEnrollModal"
                :type="14"
                @otpValidated="startNewPINInput"
              />
            </div>

            <!-- Enroll PIN -->
            <div
              v-if="is_inputting_new_pin || is_inputting_confirm_pin"
              class="flex flex-col justify-center items-center w-full"
            >
              <!-- New PIN -->
              <div
                v-if="is_inputting_new_pin"
                class="flex flex-col items-center w-full"
              >
                <div class="w-full self-start mb-5">
                  <LabelControl
                    class="text-left w-full"
                    type="heading"
                    :content="$t('mip020')"
                  />
                </div>
                <div class="flex justify-center items-center w-full">
                  <KeypadControl
                    ref="NewPINKeypad"
                    input_type="PIN"
                    @digits-full="savePIN"
                  />
                  <!-- <div class="pin-btn" style="width: 37rem;">
                                        <ButtonControl @click="submitPIN()" :disabled="!isPINValid" :button_loading="this.loading"
                                            class='w-full' :text="$t('btn002')" />
                                    </div> -->
                </div>
              </div>

              <!-- Confirm PIN -->
              <div
                v-if="is_inputting_confirm_pin"
                class="flex flex-col items-center w-full"
              >
                <div class="w-full self-start mb-5">
                  <LabelControl
                    class="text-left w-full"
                    type="heading"
                    :content="$t('mip021')"
                  />
                </div>
                <div class="flex justify-center items-center w-full">
                  <KeypadControl
                    ref="ConfirmPINKeypad"
                    input_type="PIN"
                    @digits-full="savePIN"
                  />
                  <!-- <div class="flex w-full justify-center align-center text-center" style="margin-top: -2rem;">
                                        <div class="pin-btn" style="width: 37rem;">
                                            <ButtonControl @click="submitPIN()" :disabled="!isPINValid" :button_loading="this.loading"
                                                class='w-full' :text="$t('btn002')" />
                                        </div>
                                    </div> -->
                </div>
              </div>
            </div>
          </div>
        </ContentSection>
      </div>
      <FooterSection />
    </div>

    <transition name="slide-in">
      <ModalControl :is_visible="this.is_modal_open" is_scrollable is_table>
        <div class="flex flex-col justify-center pt-10 px-10">
          <LabelControl
            type="dynamic"
            class="text-grey-darkest font-bold text-6xl mb-8 uppercase text-center"
            content="Privacy Policy"
          />

          <PrivacyPolicyControl />

          <div
            class="flex flex-row justify-center align-center items-center w-full"
            style="gap: 3rem"
          >
            <ButtonControl
              text="I Disagree"
              theme="error"
              @click="is_modal_open = false"
              class="w-full"
            />
            <ButtonControl
              text="I Agree"
              class="px-8 mr-5 w-full"
              theme="success"
              @click="toggleEnrollPINModal()"
            />
          </div>
        </div>
      </ModalControl>
    </transition>
  </div>
</template>

<script>
import SidebarSection from "@/components/sections/SidebarSection.vue";
import ContentSection from "@/components/sections/ContentSection.vue";
import FooterSection from "@/components/sections/FooterSection.vue";
import LabelControl from "@/components/controls/LabelControl.vue";
import IconControl from "@/components/controls/IconControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import OTPModalControl from "@/components/controls/OTPModalControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";
import PrivacyPolicyControl from "@/components/controls/PrivacyPolicyControl.vue";
import mixin from "@/mixins/controls.js";
import user from "@/services/user";
import KeypadControl from "@/components/controls/KeypadControl.vue";

export default {
  name: "EnrollPINView",
  mixins: [mixin],
  components: {
    SidebarSection,
    ContentSection,
    ButtonControl,
    FooterSection,
    LabelControl,
    IconControl,
    OTPModalControl,
    ModalControl,
    PrivacyPolicyControl,
    KeypadControl,
  },
  inject: ["setLoading", "setError"],
  emits: ["logout", "checkauth", "toggleRating"],
  mounted() {
    this.$emit("checkauth", false);
    const enrollee = this.$store.state.pin_enrollment;
    this.enrollee_mobile = enrollee.mobile;
    this.enrollee_email = enrollee.email;
    this.enrollee_name = enrollee.name;
    this.enrollee_uuid = enrollee.uuid;
    this.enrollee_hash = enrollee.hash;
    this.enrollee_account = enrollee.account;
    this.enrollee_account_type = enrollee.account_type;
    window.addEventListener("touchstart", this.resetInactivityTimer);
  },
  beforeUnmount() {
    clearTimeout(this.inactivity_timeout);
    window.removeEventListener("touchstart", this.resetInactivityTimer);
  },
  props: {
    is_editing_pin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      inactivity_timeout: null,
      is_modal_open: false,
      hash: this.$store.state.pin_enrollment.hash,
      uuid: this.$store.state.pin_enrollment.uuid,
      mobile: this.$store.state.pin_enrollment.mobile,
      email: this.$store.state.pin_enrollment.email,
      name: this.$store.state.pin_enrollment.name,
      is_inputting_old_pin: this.is_editing_pin,
      is_inputting_new_pin: !this.is_editing_pin,
      is_inputting_confirm_pin: false,
      qr: this.$store.state.user.qr,
      loading: false,
      new_pin: "",
      confirm_pin: "",
      enrollee_name: "",
      enrollee_mobile: "",
      enrollee_email: "",
      enrollee_uuid: "",
      enrollee_hash: "",
      enrollee_account: "",
      enrollee_account_type: "",
    };
  },
  computed: {
    getCensoredEmail() {
      if (this.email) {
        let [local_part, domain_part] = this.email.split("@");
        const censored_count = Math.ceil(this.email.length * 0.7);
        const indices = Array.from({ length: this.email.length }, (_, i) => i);
        const eligible_indices = indices.slice(2);

        // shuffling string indices
        for (let i = eligible_indices.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [eligible_indices[i], eligible_indices[j]] = [
            eligible_indices[j],
            eligible_indices[i],
          ];
        }

        const censored_indices = eligible_indices.slice(0, censored_count);
        local_part = local_part
          .split("")
          .map((char, i) => (censored_indices.includes(i) ? "*" : char))
          .join("");

        return `${local_part}@${domain_part}`;
      }
      return "";
    },
    getCensoredNumber() {
      return this.mobile
        ? this.mobile.slice(0, 5) +
            "*".repeat(this.mobile.length - 9) +
            this.mobile.slice(-4)
        : "";
    },
    isPINValid() {
      if (this.is_inputting_new_pin) {
        return this.new_pin.length == 6;
      } else if (this.is_inputting_confirm_pin) {
        return this.confirm_pin.length == 6;
      } else {
        return false;
      }
    },
  },

  methods: {
    resetInactivityTimer() {
      clearTimeout(this.inactivity_timeout);
      this.startInactivityTimer();
    },
    startInactivityTimer() {
      if (process.env.VUE_APP_DEVELOPMENT_MODE === "false") {
        this.inactivity_timeout = setTimeout(() => {
          this.$router.push({ name: "start-page" });
        }, process.env.VUE_APP_IDLE_DELAY || 30000);
      }
    },
    returnToStartPage() {
      this.$router.go(-1);
    },
    toggleEnrollPINModal() {
      this.is_modal_open = false;
      this.$refs.PINEnrollModal.openRequestOTPModal();
    },
    logout() {
      this.$emit("logout");
    },
    startNewPINInput() {
      this.is_inputting_new_pin = true;
      this.is_inputting_confirm_pin = false;
    },
    clearConfirmPINKeypad() {
      this.$refs.ConfirmPINKeypad.clearDigits();
    },
    savePIN(pin) {
      const pinStr = pin.join("");
      const isEasyPIN = (pin) => {
        return (
          /^(\d)\1+$/.test(pin) || // Checks if all digits are the same (e.g., "9999")
          "0123456789".includes(pin) || // Checks for ascending sequences
          "9876543210".includes(pin)
        ); // Checks for descending sequences
      };

      if (isEasyPIN(pinStr)) {
        this.showError("PIN is too simple. Please choose a more secure PIN.");
        return;
      }

      if (this.is_inputting_new_pin) {
        this.new_pin = pinStr;
        this.is_inputting_new_pin = false;
        this.is_inputting_confirm_pin = true;
      } else if (this.is_inputting_confirm_pin) {
        this.confirm_pin = pin.join("");
        this.submitPIN();
      }
    },
    submitPIN() {
      this.setLoading(true);
      if (this.is_inputting_new_pin) {
        this.is_inputting_new_pin = false;
        this.is_inputting_confirm_pin = true;
      } else if (this.is_inputting_confirm_pin) {
        if (this.new_pin != this.confirm_pin) {
          this.showError("PINs do not match. Please try again.");
          this.setLoading(false);
          this.confirm_pin = "";
          this.clearConfirmPINKeypad();
          return;
        }
        this.loading = true;
        // this.setLoading(true);
        user
          .enrollPIN(
            this.enrollee_hash,
            this.enrollee_uuid,
            this.$store.state.pin_enrollment.otp_token,
            this.$store.state.pin_enrollment.otp_pin,
            this.enrollee_account,
            this.new_pin,
            this.enrollee_account_type
          )
          .then((response) => {
            if (
              this.enrollee_account_type == 3 ||
              this.enrollee_account_type == 4
            ) {
              user
                .createSessionAccount(
                  response.data.data.hash,
                  this.enrollee_account,
                  this.enrollee_account_type
                )
                .then((response) => {
                  this.saveUserData(response.data.data);
                  this.$router.push({ name: "services-page" }).then(() => {
                    this.showSuccess("Login successful!");
                    this.loading = false;
                    this.setLoading(false);
                  });
                })
                .catch((error) => {
                  this.showError(error.response.data.message);
                  this.loading = false;
                  this.setLoading(false);
                });
            } else if (this.enrollee_account_type == 2) {
              user
                .createSessionQR(
                  response.data.data.hash,
                  this.enrollee_account,
                  this.enrollee_account_type
                )
                .then((response) => {
                  this.saveUserData(response.data.data);
                  this.$router.push({ name: "services-page" }).then(() => {
                    this.closeEditModal();
                    this.showSuccess("Login successful!");
                    this.loading = false;
                    this.setLoading(false);
                  });
                })
                .catch((error) => {
                  this.showError(error.response.data.message);
                  this.loading = false;
                  this.setLoading(false);
                });
            }
          })
          .catch((error) => {
            this.showError(error.response.data.message);
            this.loading = false;
            this.setLoading(false);
          });
      }
    },
  },
};
</script>

<style scoped>
.papsi-mascot {
  bottom: 0;
  left: 0;
  width: 25rem;
}

.papsi-container-enroll {
  height: 22rem;
  width: 50rem;
}

.papsi-text {
  height: 36rem;
}

@media (min-width: 2500px) {
  .papsi-container-enroll {
    width: 70rem !important;
    height: 30rem !important;
    border-radius: 1rem !important;
  }

  .papsi-button {
    width: 70rem !important;
  }

  .px-6 {
    padding: 1.5rem 2rem !important;
  }
}
</style>
